<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Configurações do sistema"></fccTitlePage>
      <fccTable
        responsive
        striped
        hover
        porPage="100"
        add-filter
        search
        pagination
        titlePage="Controle de versão"
        titlePDF="Controle de versão"
        :fields="fieldsUpload"
        :items="lstVersao"
      >
      </fccTable>
      <fccModal
        centered
        titleModal="Opção de campo"
        idModal="addControleVersao"
        size="lg"
        fechar
        travaEsc
        travaBack
      >
        <b-form autocomplete="off" @submit.prevent="addVersao">
          <b-row>
            <b-col sm="6">
              <fccInput v-model="lstVersion.versao" extraClasses="inputLabel"> Versão</fccInput>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-form-textarea
                id="textarea"
                v-model="lstVersion.releasenotes"
                placeholder="Enter something..."
                rows="5"
                :state="lstVersion.releasenotes != null && lstVersion.releasenotes.length > 5"
                max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton
                classeAdd="form-control"
                :disabled="lstVersion.releasenotes == null || lstVersion.releasenotes.length < 5"
                tipo="submit"
                >{{ labelsSystem.salvar }}</fccButton
              >
            </div>
          </div>
        </b-form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      lstVersao: [],
      lstVersion: {},
      fieldsUpload: [
        { key: 'id', label: 'ID Config', sortable: true },
        { key: 'versao', label: 'Versão', sortable: true },
        { key: 'releasenotes', label: 'Descrição', sortable: true }
      ]
    }
  },
  methods: {
    listaVersao() {
      this.carregaTexto('Carregando informações')
      axios
        .get(
          store.state.baseUrlPublicacao + 'PublicacaoControleVersao/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstVersao = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    addVersao() {
      this.carregaTexto('Salvando informações')
      axios
        .post(
          store.state.baseUrlPublicacao + 'PublicacaoControleVersao/Inserir',
          this.lstVersion,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'addControleVersao')
          this.listaVersao()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    addField() {
      this.lstVersion = {}
      this.lstVersao.id = 0
      this.$root.$emit('bv::show::modal', 'addControleVersao')
    }
  },
  created() {
    this.listaVersao()
  }
}
</script>
